
<template>
  <div v-if="extras.length > 0 && totalExtrasQuantitySelected > 0">
    <div class="row">
      <div class="col-md-12 mt-3 mb-3">
        <b>Travel extras:</b>
      </div>
    </div>
    <div
      v-for="(extra, extraIndex) in extras"
      :key="extraIndex"
    >
      <div
        v-if="isExtraSelected(extra)"
      >
        <div class="col-10 content-list mb-2">
          <div>
            <b>
              {{ extra.name.trim() }}
              <br>
              <small
                v-for="(offerline, offerlineIndex) in extra.offerLines"
                :key="offerline.id"
              >
                ({{ offerline.quantity }}) {{ offerline.name.trim() }}
                <i
                  v-if="offerlineIndex + 1 != extra.offerLines.length"
                >,</i>
              </small>
            </b>
          </div>
          <div
            class="col-4"
          >
            <span>: {{ $n(extra.totalPrice, 'currency', languageCode) }}</span>
          </div>
        </div>
        <div
          v-if="isExtraDiscrepant(extra.id)"
          class="col-12 small text--error"
        >
          The price of this extra has {{ getDiscrepancyById(extra.id).type }} by {{ Math.abs(extra.totalPrice - $n(getDiscrepancyById(extra.id).oldPrice), 'currency', languageCode) }}
        </div>
        <hr>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'BookingSummaryExtras',
    props:
        {
            extras: {
                type: Array,
                default: () => []
            },
            discrepancies: {
                type: Array,
                default: () => []
            }
        },
    computed: {
        totalExtrasQuantitySelected: function () {
            var totalExtrasQuantitySelected = 0
            this.extras.forEach(extra => {
                extra.offerLines.forEach(offerline => {
                    totalExtrasQuantitySelected += offerline.quantity
                })
            })

            return totalExtrasQuantitySelected
        },
        languageCode () {
            var code = this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
            if (code !== null) {
                return code
            }
            return 'en-GB'
        }
    },
    methods: {
        isExtraDiscrepant (id) {
            return !!this.discrepancies.find((discrepancy) => {
                if (id.toString() === discrepancy.id.toString()) return true
            })
        },
        getDiscrepancyById (id) {
            return this.discrepancies.find((discrepancy) => {
                if (id.toString() === discrepancy.id.toString()) return true
            })
        },
        isExtraSelected: function (extra) {
            var extraQuantitySelected = 0
            extra.offerLines.forEach(offerline => {
                extraQuantitySelected += offerline.quantity
            })
            return extraQuantitySelected > 0
        }
    }
}
</script>
